import { render, staticRenderFns } from "./CheckoutSuggestions.vue?vue&type=template&id=360f9c24"
import script from "./CheckoutSuggestions.vue?vue&type=script&lang=ts"
export * from "./CheckoutSuggestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360f9c24')) {
      api.createRecord('360f9c24', component.options)
    } else {
      api.reload('360f9c24', component.options)
    }
    module.hot.accept("./CheckoutSuggestions.vue?vue&type=template&id=360f9c24", function () {
      api.rerender('360f9c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/CheckoutSuggestions.vue"
export default component.exports